import { faCheck, faCheckDouble } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useRef, useState } from "react";
import CurrencyFormat from "react-currency-format";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { json } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import {
  resetMessage,
  sanctionLoanOffer,
  sendLoanOfferMsg,
} from "../../../redux/slices/financer";
import { dispatch } from "../../../redux/store";
import axiosInstance from "../../../utils/axios";
import { currencySymbol, DateFormat } from "../../../utils/helpers";
import { finaciarChatValidation } from "./ChatBoxInputValidations";
import Swal from "sweetalert2";
import {
  acceptLoanOffer,
  getLoanOfferMsg,
  getMessages,
  sendMessage,
} from "../../../redux/slices/loanOffers";
export default function ChatBox({
  user,
  messages,
  loanId,
  setMessages,
  conversations,
  setConversations,
}) {
  const { user: user1, isAuthenticated } = useAuth();
  const { messageSent, isSanction } = useSelector((state) => state.financer);
  const { isAgreed } = useSelector((state) => state.loanOffers);
  const endOfChat = useRef(null);
  const [inputValues, setInputValues] = useState({
    amount: 0,
    roi: 0,
    tenure: 0,
    processingFee: 0,
    message: "",
  });
  const [sendOffer, setSendOffer] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    mode: "all",
    resolver: yupResolver(finaciarChatValidation),
    defaultValues: {
      amount: 0,
      roi: 0,
      tenure: 0,
      processingFee: 0,
      message: "",
    },
  });
  const [msg, setMsg] = useState("");
  // const handleMsgChange = (e) => {
  // 	const {name, value} = e.target
  // 	setMsg(value)
  // }
  const { user: loggedInUser } = useAuth();

  const handleMessageSubmit = (data) => {
    const { message, tenure, roi, amount, processingFee } = data;
    let messageBody = {
      message,
    };

    if (sendOffer) {
      messageBody = {
        message,
        tenure,
        roi,
        amount,
        processingFee,
      };
    }
    // const chatMessage =
    //   "Amount : " +
    //   data?.amount +
    //   " " +
    //   " Message : " +
    //   data.message +
    //   " " +
    //   "Rate of Interest : " +
    //   data?.roi +
    //   " " +
    //   "Tenure : " +
    //   data?.tenure;
    if (amount > 0 && roi > 0 && tenure > 0) {
      dispatch(sendLoanOfferMsg({ loanId, message: messageBody, sendOffer }))
        .unwrap()
        .then((res) => {
          if (res.success) {
            dispatch(getLoanOfferMsg(loanId))
              .unwrap()
              .then((res) => {
                if (res?.success) {
                  setMessages(res?.financierOffers);
                }
              });

            setInputValues({
              amount: 0,
              roi: 0,
              tenure: 0,
              processingFee: 0,
              message: "",
            });
            setSendOffer(false);

            // setMessages((prev) => [
            //   ...prev,
            //   {
            //     sent_by: loggedInUser.id,
            //     created_at: dateNow,
            //     offer_description: message,
            //     roi,
            //     tenure,
            //     amount,
            //   },
            // ]);
            reset();
          }
        });
    }
    setInputValues({
      amount: 0,
      roi: 0,
      tenure: 0,
      processingFee: 0,
      message: "",
    });
    endOfChat.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleClickCheckbox = (e) => {
    setSendOffer((prev) => !prev);
    setInputValues((prev) => {
      return { ...prev, amount: 0, roi: 0, tenure: 0 };
    });
    reset({
      amount: 0,
      roi: 0,
      tenure: 0,
    });
  };

  useEffect(() => {
    endOfChat.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSanction = () => {
    if (
      window.confirm(
        "Once you sanction then you will not be able to negotiate again. Are you agree with customer offer ?"
      )
    ) {
      dispatch(
        sanctionLoanOffer({
          id: messages[messages.length - 1].id,
          loan_id: messages[messages.length - 1].loan_id,
          loan_offer_id: messages[messages.length - 1].loan_offer_id,
          amount: messages[messages.length - 1].amount,
          roi: messages[messages.length - 1].roi,
          tenure: messages[messages.length - 1].tenure,
          message: messages[messages.length - 1]?.offer_description,
        })
      )
        .unwrap()
        .then((res) => {
          if (res.success) {
            dispatch(
              getLoanOfferMsg(messages[messages.length - 1]?.loan_offer_id)
            )
              .unwrap()
              .then((res) => {
                if (res?.success) {
                  setMessages(res?.offerMsgs);
                }
              });
          }
        })
        .unwrap()
        .then((res) => {
          Swal.fire({
            icon: "success",
            text: "Loan details sanctioned!",
          });
        });
      // setInputValues({
      //   amount: messages[messages.length - 1]?.amount,
      //   roi: messages[messages.length - 1]?.roi,
      //   tenure: messages[messages.length - 1]?.tenure,
      //   message: messages[messages.length - 1]?.offer_description,
      // });
      // .unwrap()
      // .then(async (res) => {
      // setInputValues({
      //   amount: messages[messages.length - 1].amount,
      //   roi: messages[messages.length - 1].roi,
      //   tenure: messages[messages.length - 1].tenure,
      //   message: messages[messages.length - 1].message,
      // });
      // console.log({ res });
      // let postData = {
      //   amount: messages[messages.length - 1].amount,
      //   roi: messages[messages.length - 1].roi,
      //   tenure: messages[messages.length - 1].tenure,
      //   message: messages[messages.length - 1].message,
      // };

      // const response = axiosInstance
      //   .post("/new-counter-offer", { ...postData })
      //   .then((response) => {
      //     console.log({ response });
      //   });
      // Swal.fire({
      //   icon: "success",
      //   text: "Customer offer accepted successfully!",
      // });

      // refreshSupplierQuote();
      // });
    }
  };

  const handleAgree = () => {
    if (
      window.confirm(
        "Once you agreed then you will not be able to negotiate again. Are you agree with Customers offer ?"
      )
    ) {
      if (messages.length > 0) {
        let data = {
          amount: messages[messages.length - 1]?.amount,
          roi: messages[messages.length - 1]?.roi,
          tenure: messages[messages.length - 1]?.tenure,
          message: messages[messages.length - 1]?.offer_description,
        };
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            // cancelButton: "btn btn-danger mx-3",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            title: "Loan offer",
            // showCancelButton: true,
            // cancelButtonColor: "#d33",
            html: `
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td>Amount:</td>
              <td>${data.amount}</td>
            </tr>
            <tr>
              <td>ROI:</td>
              <td>${data.roi}%</td>
            </tr>
            <tr>
            <td>Tenure:</td>
            <td>${data.tenure}</td>
          </tr>
          <tr>
              <td>Message:</td>
              <td>${data.message}</td>
              
            </tr>
          </tbody>
        </table>`,
          })
          .then(() => {
            dispatch(
              acceptLoanOffer({
                id: messages[messages.length - 1]?.id,
                loan_id: messages[messages.length - 1]?.loan_id,
                loan_offer_id: messages[messages.length - 1]?.loan_offer_id,
                amount: messages[messages.length - 1]?.amount,
                roi: messages[messages.length - 1]?.roi,
                tenure: messages[messages.length - 1]?.tenure,
                message: messages[messages.length - 1]?.offer_description,
              })
            )
              .unwrap()
              .then((res) => {
                if (res.success) {
                  dispatch(
                    getLoanOfferMsg(
                      messages[messages.length - 1]?.loan_offer_id
                    )
                  )
                    .unwrap()
                    .then((res) => {
                      if (res?.success) {
                        setMessages(res?.offerMsgs);
                      }
                    });
                }
              });
          });
      } else {
        let data = {
          amount: user?.amount_requested,
          roi: user?.requested_roi,
          tenure: user?.requested_tenure,
          // message: user?.additional_note,
        };
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success",
            // cancelButton: "btn btn-danger mx-3",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            title: "Loan offer",
            // showCancelButton: true,
            // cancelButtonColor: "#d33",
            html: `
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td>Amount:</td>
              <td>${data.amount}</td>
            </tr>
            <tr>
              <td>ROI:</td>
              <td>${data.roi}%</td>
            </tr>
            <tr>
            <td>Tenure:</td>
            <td>${data.tenure}</td>
          </tr>
          </tbody>
        </table>`,
          })
          .then(() => {
            dispatch(
              acceptLoanOffer({
                id: user?.id,
                loan_id: user?.loan_id,
                // loan_offer_id: messages[messages.length - 1]?.loan_offer_id,
                amount: user?.amount_requested,
                roi: user?.requested_tenure,
                tenure: user?.requested_tenure,
                // message: messages[messages.length - 1]?.offer_description,
              })
            )
              .unwrap()
              .then((res) => {
                if (res.success) {
                  dispatch(
                    getLoanOfferMsg(
                      messages[messages.length - 1]?.loan_offer_id
                    )
                  )
                    .unwrap()
                    .then((res) => {
                      if (res?.success) {
                        setMessages(res?.offerMsgs);
                      }
                    });
                }
              });
          });
      }
      // dispatch(
      //   acceptLoanOffer({
      //     id: messages[messages.length - 1]?.id,
      //     loan_id: messages[messages.length - 1]?.loan_id,
      //     loan_offer_id: messages[messages.length - 1]?.loan_offer_id,
      //     amount: messages[messages.length - 1]?.amount,
      //     roi: messages[messages.length - 1]?.roi,
      //     tenure: messages[messages.length - 1]?.tenure,
      //     message: messages[messages.length - 1]?.offer_description,
      //   })
      // );

      // dispatch(
      //   acceptLoanOffer({
      //     id: messages[messages.length - 1]?.id,
      //     loan_id: messages[messages.length - 1]?.loan_id,
      //     loan_offer_id: messages[messages.length - 1]?.loan_offer_id,
      //     amount: messages[messages.length - 1]?.amount,
      //     roi: messages[messages.length - 1]?.roi,
      //     tenure: messages[messages.length - 1]?.tenure,
      //     message: messages[messages.length - 1]?.offer_description,
      //   })
      // );
      // .unwrap()
      // .then(async (res) => {
      // setInputValues({
      //   amount: messages[messages.length - 1]?.amount,
      //   roi: messages[messages.length - 1]?.roi,
      //   tenure: messages[messages.length - 1]?.tenure,
      //   message: messages[messages.length - 1]?.offer_description,
      // });
      // console.log({ res });
      // let postData = {
      //   amount: messages[messages.length - 1].amount,
      //   roi: messages[messages.length - 1].roi,
      //   tenure: messages[messages.length - 1].tenure,
      //   message: messages[messages.length - 1].message,
      // };
      // const response = axiosInstance
      //   .post("/new-counter-offer", { ...postData })
      //   .then((response) => {
      //     console.log({ response });
      //   });
      // Swal.fire({
      //   icon: "success",
      //   text: "Customer offer accepted successfully!",
      // });
      // refreshSupplierQuote();
      // });
    }
  };
  // console.log({loggedInUser});
  // console.log("Message Status : ",messageSent);

  useEffect(() => {
    if (loanId) {
      dispatch(getLoanOfferMsg(loanId))
        .unwrap()
        .then((res) => {
          if (res?.success) {
            setMessages(res?.financierOffers);
          }
        });
    }
  }, []);
  const handlePaste = (event) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text");

    if (pastedText.includes("e")) {
      event.preventDefault();
    }
  };

  const handleSendMessage = (e) => {
    e.preventDefault();
    const { message } = inputValues;
    const dateTimeNow = new Date();
    dispatch(sendMessage({ loanId, message }))
      .unwrap()
      .then((res) => {
        if (res.success) {
          dispatch(getMessages(loanId)).then((response) => {
            if (response?.payload?.success) {
              setConversations(response?.payload?.offerMessages);
            }
          });
          setInputValues({
            message: "",
          });
          // setConversations((prev) => {
          //   return [
          //     ...prev,
          //     {
          //       sent_by: user.id,
          //       created_at: dateTimeNow,
          //       offer_description: message,
          //       user: user,
          //     },
          //   ];
          // });
        }
      });

    reset();
  };
  return (
    <main className="content mt-2">
      <div className="card">
        <div className="row">
          <div className="row col-12 col-lg-12 col-xl-12">
            <div className="col-6 position-relative">
              <div className="chat-messages p-5">
                {messages?.length > 0 &&
                  user !== null &&
                  messages?.map((msg, idx) => (
                    <div
                      key={idx}
                      className={
                        user?.id === msg?.sent_by
                          ? " chat-message-right pb-4 mr-5"
                          : " chat-message-left pb-4 mr-5"
                      }
                    >
                      <div>
                        {msg?.user?.profile_picture !== undefined ? (
                          <img
                            src={msg?.user?.profile_picture}
                            className="rounded-circle mr-1"
                            alt="Sharon Lessman"
                            width="40"
                            height="40"
                            style={{ objectFit: "contain" }}
                          />
                        ) : (
                          <img
                            src="https://bootdey.com/img/Content/avatar/avatar3.png"
                            className="rounded-circle mr-1"
                            alt="Sharon Lessman"
                            width="40"
                            height="40"
                            style={{ objectFit: "contain" }}
                          />
                        )}

                        <div className="text-muted small text-nowrap mt-2">
                          {}
                        </div>
                      </div>
                      <div
                        className="flex-shrink-1 bg-light rounded py-2 px-3 ml-3 ml-5"
                        style={{ width: "25rem" }}
                      >
                        <div className="font-weight-bold sm mb-1">
                          {user1?.id === msg?.sent_by
                            ? "You"
                            : msg?.user?.first_name +
                              " " +
                              (msg?.user?.last_name !== null &&
                                msg?.user?.last_name !== undefined &&
                                msg?.user?.last_name !== "")
                            ? msg?.user?.last_name
                            : ""}
                          {/* {msg?.is_sanctioned === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Sanctioned
                            </span>
                          ) : null} */}
                          {msg?.user_accepted === 1 ||
                          msg?.user_accepted === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Customer Agreed
                            </span>
                          ) : (
                            ""
                          )}
                          {/* {msg?.financer_accepted === 1 ||
                          msg?.financer_accepted === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Financer Agreed
                            </span>
                          ) : (
                            ""
                          )} */}
                        </div>
                        {msg?.amount !== null &&
                          msg?.amount !== undefined &&
                          msg?.amount !== "" &&
                          msg?.amount !== 0 && (
                            <>
                              Amount:&nbsp;
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {currencySymbol()}
                                </span>
                                <CurrencyFormat
                                  value={msg?.amount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                  decimalScale={2}
                                />
                              </span>
                              <br />
                              <hr />
                            </>
                          )}
                        {/* Tenure show */}
                        {msg?.tenure !== null &&
                          msg?.tenure !== undefined &&
                          msg?.tenure !== "" &&
                          msg?.tenure !== 0 && (
                            <>
                              Tenure:
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {msg?.tenure} Months
                                </span>
                              </span>
                              <br />
                              <hr />
                            </>
                          )}
                        {/* Rate of Intrest */}
                        {msg?.roi !== null &&
                          msg?.roi !== undefined &&
                          msg?.roi !== "" &&
                          msg?.roi !== 0 && (
                            <>
                              Rate of Interest:
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {msg?.roi} %
                                </span>
                              </span>
                              <br />
                              <hr />
                            </>
                          )}
                        {/* MEssage */}
                        {msg?.processing_fee !== null &&
                          msg?.processing_fee !== undefined &&
                          msg?.processing_fee !== "" && (
                            <>
                              Processing Fees:{" "}
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {msg?.processing_fee} %
                                </span>
                              </span>
                              <br />
                            </>
                          )}
                        <br />
                        <span style={{ fontSize: "0.7rem", color: "grey" }}>
                          {<DateFormat datestring={msg?.created_at} />}
                        </span>
                      </div>
                    </div>
                  ))}
                <div ref={endOfChat}></div>
              </div>
            </div>
            <div className="col-6">
              <div className="chat-messages p-5">
                {conversations?.length > 0 &&
                  user !== null &&
                  conversations?.map((msg, idx) => (
                    <div
                      key={idx}
                      className={
                        user1?.id === msg?.sent_by
                          ? " chat-message-right pb-4 mr-5"
                          : " chat-message-left pb-4 mr-5"
                      }
                    >
                      <div>
                        {msg?.user?.profile_picture !== undefined ? (
                          <img
                            src={msg?.user?.profile_picture}
                            className="rounded-circle mr-1"
                            alt="Sharon Lessman"
                            width="40"
                            height="40"
                            style={{ objectFit: "contain" }}
                          />
                        ) : (
                          <img
                            src="https://bootdey.com/img/Content/avatar/avatar3.png"
                            className="rounded-circle mr-1"
                            alt="Sharon Lessman"
                            width="40"
                            height="40"
                            style={{ objectFit: "contain" }}
                          />
                        )}

                        <div className="text-muted small text-nowrap mt-2">
                          {}
                        </div>
                      </div>
                      <div
                        className="flex-shrink-1 bg-light rounded py-2 px-3 ml-3 ml-5"
                        style={{ width: "25rem" }}
                      >
                        <div className="font-weight-bold sm mb-1">
                          {user?.id === msg?.sent_by
                            ? "You"
                            : msg?.user?.first_name +
                              " " +
                              (msg?.user?.last_name !== null &&
                                msg?.user?.last_name !== undefined &&
                                msg?.user?.last_name !== "")
                            ? msg?.user?.last_name
                            : ""}
                          {msg?.is_sanctioned === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Sanctioned
                            </span>
                          ) : null}
                          {msg?.user_accepted === 1 ||
                          msg?.user_accepted === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              You Agreed
                            </span>
                          ) : (
                            ""
                          )}
                          {msg?.financer_accepted === 1 ||
                          msg?.financer_accepted === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Financer Agreed
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        {/* MEssage */}
                        {msg?.message !== null &&
                          msg?.message !== undefined &&
                          msg?.message !== "" && (
                            <>
                              Message:{" "}
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {msg?.message}
                                </span>
                              </span>
                              <br />
                            </>
                          )}
                        <br />
                        <span style={{ fontSize: "0.7rem", color: "grey" }}>
                          {<DateFormat datestring={msg?.created_at} />}
                        </span>
                      </div>
                    </div>
                  ))}
                <div ref={endOfChat}></div>
              </div>
            </div>
            {/* <div className="position-relative">
              <div className="chat-messages p-5"> */}
            {/* <div className="chat-message-right pb-4">
								<div>
									<img src="https://bootdey.com/img/Content/avatar/avatar1.png" className="rounded-circle mr-1" alt="Chris Wood" width="40" height="40"/>
									<div className="text-muted small text-nowrap mt-2">2:33 am</div>
								</div>
								<div className="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
									<div className="font-weight-bold mb-1">You</div>
									Lorem ipsum dolor sit amet, vis erat denique in, dicunt prodesset te vix.
								</div>
							</div>

							<div className="chat-message-left pb-4">
								<div>
									<img src="https://bootdey.com/img/Content/avatar/avatar3.png" className="rounded-circle mr-1" alt="Sharon Lessman" width="40" height="40"/>
									<div className="text-muted small text-nowrap mt-2">2:34 am</div>
								</div>
								<div className="flex-shrink-1 bg-light rounded py-2 px-3 ml-3">
									<div className="font-weight-bold mb-1">Sharon Lessman</div>
									Sit meis deleniti eu, pri vidit meliore docendi ut, an eum erat animal commodo.
								</div>
							</div> */}

            {/* {messages?.length > 0 &&
                  loggedInUser !== null &&
                  messages?.map((msg, idx) => (
                    <div
                      key={idx}
                      className={
                        loggedInUser?.id === msg?.sent_by
                          ? " chat-message-right pb-4 mr-5"
                          : " chat-message-left pb-4 mr-5"
                      }
                    >
                      <div>
                        {msg?.user?.profile_picture !== undefined ? (
                          <img
                            src={msg?.user?.profile_picture}
                            className="rounded-circle mr-1"
                            alt="Sharon Lessman"
                            width="40"
                            height="40"
                            style={{ objectFit: "contain" }}
                          />
                        ) : (
                          <img
                            src="https://bootdey.com/img/Content/avatar/avatar3.png"
                            className="rounded-circle mr-1"
                            alt="Sharon Lessman"
                            width="40"
                            height="40"
                            style={{ objectFit: "contain" }}
                          />
                        )} */}
            {/* <img
                          src="https://bootdey.com/img/Content/avatar/avatar3.png"
                          className="rounded-circle mr-1"
                          alt="Sharon Lessman"
                          width="40"
                          height="40"
                        /> */}
            {/* <div className="text-muted small text-nowrap mt-2">{}</div> */}
            {/* </div>
                      <div
                        className="flex-shrink-1 bg-light rounded py-2 px-3 ml-3 ml-5"
                        style={{ width: "25rem" }}
                      >
                        <div className="font-weight-bold mb-1">
                          {loggedInUser?.id === msg?.sent_by
                            ? "You"
                            : user?.user?.first_name +
                              " " +
                              user?.user?.last_name}
                          {msg?.is_sanctioned === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Sanctioned
                            </span>
                          ) : null}
                          {msg?.user_accepted === 1 ||
                          msg?.user_accepted === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              Customer Agreed
                            </span>
                          ) : (
                            ""
                          )}
                          {msg?.financer_accepted === 1 ||
                          msg?.financer_accepted === true ? (
                            <span className="badge rounded-pill bg-success mx-1">
                              You Agreed
                            </span>
                          ) : (
                            ""
                          )}
                        </div> */}
            {/* Amount */}
            {/* {msg?.amount !== null &&
                          msg?.amount !== undefined &&
                          msg?.amount !== "" &&
                          msg?.amount !== 0 && (
                            <>
                              Amount:&nbsp;
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {currencySymbol()}
                                </span>
                                <CurrencyFormat
                                  value={msg?.amount}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  fixedDecimalScale={true}
                                  decimalScale={2}
                                />
                              </span>
                              <br />
                              <hr />
                            </>
                          )} */}
            {/* Tenure show */}
            {/* {msg?.tenure !== null &&
                          msg?.tenure !== undefined &&
                          msg?.tenure !== "" &&
                          msg?.tenure !== 0 && (
                            <>
                              Tenure:
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {msg?.tenure} Months
                                </span>
                              </span>
                              <br />
                              <hr />
                            </>
                          )} */}
            {/* Rate of Intrest */}
            {/* {msg?.roi !== null &&
                          msg?.roi !== undefined &&
                          msg?.roi !== "" &&
                          msg?.roi !== 0 && (
                            <>
                              Rate of Interest:
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {msg?.roi} %
                                </span>
                              </span>
                              <br />
                              <hr />
                            </>
                          )} */}
            {/* MEssage */}
            {/* {msg?.offer_description !== null &&
                          msg?.offer_description !== undefined &&
                          msg?.offer_description !== "" && (
                            <>
                              Message:{" "}
                              <span className="counter_chat_price">
                                <span className="price-symbol">
                                  {msg?.offer_description}
                                </span>
                              </span>
                              <br />
                            </>
                          )}
                        <br />
                        <span
                          style={{ fontSize: "0.7rem", color: "grey" }}
                          className="d-flex justify-content-between"
                        >
                          {<DateFormat datestring={msg?.created_at} />}
                        </span>
                      </div>
                    </div>
                  ))}
                <div ref={endOfChat}></div>
              </div>
            </div> */}
            <div className="row">
              <div className="col-6">
                <form onSubmit={handleSubmit(handleMessageSubmit)}>
                  <div className="flex-grow-0 py-3 px-4 border-top">
                    <div className="input-group table-responsive">
                      <table className="table table-bordered table-scroll">
                        <thead>
                          <tr>
                            <th
                              colSpan={4}
                              style={{ textAlign: "center" }}
                              className="text-white"
                            >
                              Send Offer
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan={4}>
                              <div className="d-flex flex-row align-content-center justify-content-start">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={sendOffer}
                                  {...register("sendOffer")}
                                  value={sendOffer}
                                  name="sendOffer"
                                  id="sendOffer"
                                  onClick={handleClickCheckbox}
                                  // disabled={
                                  //   messages[messages.length - 1]
                                  //     ?.is_sanctioned === true
                                  //     ? true
                                  //     : false ||
                                  //       messages[messages.length - 1]
                                  //         ?.financer_accepted === 1 ||
                                  //       messages[messages.length - 1]
                                  //         ?.financer_accepted === true
                                  // }
                                />
                                &nbsp;
                                <label
                                  htmlFor="sendOffer"
                                  className="form-check-label"
                                >
                                  Send Offer
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="col-3"
                              style={{ opacity: !sendOffer ? "0.5" : "1" }}
                            >
                              <label>
                                Amount (in Rs.){" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("amount")}
                                name="amount"
                                type={"number"}
                                className="form-control hide-arrow"
                                id="CounterPrice"
                                onChange={(e) => handleInputChange(e)}
                                min={0}
                                step={1.0}
                                onPaste={handlePaste}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                onWheel={(e) => e.target.blur()}
                                value={inputValues?.amount}
                                disabled={!sendOffer}
                                // defaultValue={latestPrice}
                              />
                              <span className="text-danger">
                                {errors?.amount?.message}
                              </span>
                            </td>
                            <td
                              className="col-3"
                              style={{ opacity: !sendOffer ? "0.5" : "1" }}
                            >
                              <label>
                                ROI (in %)<span className="text-danger">*</span>
                              </label>
                              <input
                                name="roi"
                                {...register("roi")}
                                disabled={!sendOffer}
                                // type="text"
                                type="number"
                                // pattern="[0-9]*"
                                step="0.01"
                                min="0"
                                max="100"
                                pattern="[0-9]+"
                                className="form-control"
                                id="CounterQuantity"
                                onPaste={handlePaste}
                                onChange={(e) => handleInputChange(e)}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                value={inputValues?.roi}
                                onWheel={(e) => e.target.blur()}
                              />
                              <span className="text-danger">
                                {errors?.roi?.message}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="col-3"
                              style={{ opacity: !sendOffer ? "0.5" : "1" }}
                            >
                              <label>
                                Tenure (in Months)
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("tenure")}
                                name="tenure"
                                // type="text"
                                type={"number"}
                                disabled={!sendOffer}
                                // pattern="[0-9]*"
                                // min="0"
                                pattern="[0-9]+"
                                className="form-control"
                                id="CounterQuantity"
                                min={0}
                                onPaste={handlePaste}
                                onChange={(e) => handleInputChange(e)}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                value={inputValues?.tenure}
                                onWheel={(e) => e.target.blur()}
                              />
                              <span className="text-danger">
                                {errors?.tenure?.message}
                              </span>
                            </td>

                            <td
                              className="col-3"
                              style={{ opacity: !sendOffer ? "0.5" : "1" }}
                            >
                              <label>
                                Processing fees (in %)
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("processingFee")}
                                name="processingFee"
                                disabled={!sendOffer}
                                // type="text"
                                type="number"
                                // pattern="[0-9]*"
                                step="0.01"
                                min="0"
                                max="100"
                                pattern="[0-9]+"
                                className="form-control"
                                id="CounterQuantity"
                                onPaste={handlePaste}
                                onChange={(e) => handleInputChange(e)}
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                value={inputValues?.processingFee}
                                onWheel={(e) => e.target.blur()}
                              />
                              <span className="text-danger">
                                {errors?.processingFee?.message}
                              </span>
                            </td>
                          </tr>
                          {/* <tr>
                            <td colSpan={4} rowSpan={4}>
                              <label>
                                Message<span className="text-danger">*</span>
                              </label>
                              <textarea
                                {...register("message")}
                                onChange={(e) => handleInputChange(e)}
                                value={inputValues?.message}
                                name="message"
                                type={"text"}
                                rows={3}
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                placeholder="Type your message here"
                                disabled={
                                  messages[messages.length - 1]
                                    ?.is_sanctioned === true
                                    ? true
                                    : false || isSanction
                                }
                              ></textarea>
                              <span className="text-danger">
                                {errors?.message?.message}
                              </span>
                            </td>
                            {/* <td colSpan={2} rowSpan={2}>
                          
                        </td> */}
                          {/* </tr> */}
                        </tbody>
                      </table>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        // disabled={
                        //   messages[messages.length - 1]?.sent_by ===
                        //     user1?.id ||
                        //   messages[messages.length - 1]?.financer_accepted ===
                        //     1 ||
                        //   messages[messages.length - 1]?.financer_accepted ===
                        //     true ||
                        //   messages[messages.length - 1]?.user_accepted === 1 ||
                        //   messages[messages.length - 1]?.user_accepted === true
                        // }
                      >
                        Send
                      </button>
                      {/* {(messages[messages.length - 1]?.sent_by !== user1?.id ||
                    messages[messages.length - 1]?.user_accepted === true ||
                    messages[messages.length - 1]?.user_accepted === 1) && (
                    <button
                      type="button"
                      className="btn btn-success mx-2"
                      onClick={handleAgree}
                      disabled={
                        messages[messages.length - 1]?.status === "Accepted" ||
                        isAgreed?.status === "Accepted"
                          ? true
                          : false ||
                            messages[messages.length - 1]?.financer_accepted ===
                              1 ||
                            messages[messages.length - 1]?.financer_accepted ===
                              true
                      }
                    >
                      Agree
                    </button>
                  )}
                  {(messages[messages.length - 1]?.financer_accepted === 1 ||
                    messages[messages.length - 1]?.financer_accepted ===
                      true) &&
                    (messages[messages.length - 1]?.user_accepted === 1 ||
                      messages[messages.length - 1]?.user_accepted ===
                        true) && (
                      <button
                        type="button"
                        className="btn btn-success mx-2"
                        disabled={
                          messages[messages.length - 1]?.is_sanctioned === true
                            ? true
                            : false || isSanction
                        }
                        onClick={handleSanction}
                      >
                        Sanction
                      </button>
                    )} */}
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-6">
                <form>
                  <div className="input-group table-responsive py-3 px-4">
                    <table className="table table-bordered table-scroll">
                      <thead>
                        <tr>
                          <th
                            style={{ textAlign: "center" }}
                            className="text-white"
                          >
                            Send message
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <label>
                              {" "}
                              Message<span className="text-danger">*</span>
                            </label>
                            <textarea
                              {...register("message")}
                              onChange={(e) => handleInputChange(e)}
                              value={inputValues?.message}
                              name="message"
                              type={"text"}
                              rows={3}
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              placeholder="Type your message here"
                            ></textarea>
                            <span className="text-danger">
                              {errors?.message?.message}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <button
                      className="btn btn-primary"
                      onClick={handleSendMessage}
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
